/* Duskhaven UX pass (Sept 2026): search panel and cart drawer helpers.
 * 1. Header search bridge: the header's search field opens the theme's predictive search panel
 *    (#search-modal), carrying over what was typed, so shoppers get live product and collection results.
 *    Without JavaScript, or if the panel is missing, the field still submits to /search as before.
 * 2. "Popular" chips in the empty search panel run a live search instead of leaving the page.
 * 3. "Add" on the empty-cart picks adds the item and refreshes the drawer in place.
 * 4. <dh-cart-arrival> (2026-10-03): real arrival dates in the cart (snippets/dh-cart-faq.liquid). */
(function () {
  if (window.__dhUxList) return;
  window.__dhUxList = true;

  /* ---------- Search ---------- */

  function searchModal() {
    var modal = document.getElementById('search-modal');
    return modal && typeof modal.showDialog === 'function' ? modal : null;
  }

  function modalInput() {
    return document.querySelector('#search-modal predictive-search-component input[type="search"]');
  }

  function runSearch(input, value) {
    input.value = value;
    input.focus();
    try {
      input.setSelectionRange(value.length, value.length);
    } catch (e) {}
    if (!value.trim()) return;
    var event;
    try {
      event = new InputEvent('input', { bubbles: true, inputType: 'insertText', data: value });
    } catch (e) {
      event = new Event('input', { bubbles: true });
    }
    input.dispatchEvent(event);
  }

  function openFromHeader(headerInput, extra) {
    var modal = searchModal();
    var input = modalInput();
    if (!modal || !input) return false;
    var value = (headerInput.value || '') + (extra || '');
    modal.showDialog();
    headerInput.blur();
    // Wait a frame so the dialog is open before focusing its field.
    requestAnimationFrame(function () { runSearch(input, value); });
    return true;
  }

  function isHeaderSearch(el) {
    return el && el.matches && el.matches('form.dh-nav-search input[name="q"]');
  }

  // Click or tap in the header field opens the panel.
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (isHeaderSearch(target)) {
      if (openFromHeader(target, '')) event.preventDefault();
      return;
    }
    // Popular chips inside the panel: search in place.
    var chip = target.closest('[data-dh-search-term]');
    if (chip && chip.closest('predictive-search-component')) {
      var input = modalInput();
      if (input && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        event.preventDefault();
        runSearch(input, chip.getAttribute('data-dh-search-term') || chip.textContent.trim());
      }
    }
  });

  // Typing in the header field (after tabbing to it) also opens the panel, keeping the keystroke.
  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!isHeaderSearch(target)) return;
    if (event.key.length !== 1 || event.metaKey || event.ctrlKey || event.altKey) return;
    if (openFromHeader(target, event.key)) event.preventDefault();
  });

  /* ---------- Cart drawer picks ---------- */

  var eventsModule = null;
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = new Promise(function (resolve) {
        var done = function () { resolve(window.__dhShopifyEvents || null); };
        if (window.__dhShopifyEvents) { done(); return; }
        document.addEventListener('dh:shopify-events', done, { once: true });
        setTimeout(done, 3000);
        var script = document.createElement('script');
        script.type = 'module';
        script.textContent = "import('@shopify/events').then(function (m) { window.__dhShopifyEvents = m; })" +
          ".catch(function () {}).then(function () { document.dispatchEvent(new Event('dh:shopify-events')); });";
        document.head.appendChild(script);
      });
    }
    return eventsModule;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-dh-ux-cart-add]')) return;
    event.preventDefault();
    var button = form.querySelector('button');
    if (button.disabled) return;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    var variantId = form.querySelector('[name="id"]').value;
    var body = new FormData(form);
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (element) {
      if (element.dataset && element.dataset.sectionId && sectionIds.indexOf(element.dataset.sectionId) === -1) {
        sectionIds.push(element.dataset.sectionId);
      }
    });
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    loadEvents().then(function (events) {
      var Update = events && events.CartLinesUpdateEvent;
      var deferred = Update ? Update.createPromise() : null;
      if (deferred) {
        form.dispatchEvent(new Update({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));
      }
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
        credentials: 'same-origin'
      })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result.status) throw new Error(result.description || result.message || 'Could not add to cart');
          return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              if (deferred) {
                deferred.resolve({
                  cart: Update.createCartFromAjaxResponse(cart),
                  detail: { items: cart.items, source: 'dh-cart-picks', itemCount: 1, productId: String(result.product_id || ''), sections: result.sections, didError: false }
                });
              } else {
                window.location.href = rootUrl() + 'cart';
              }
              document.dispatchEvent(new CustomEvent('duskhaven:cart-updated'));
            });
        })
        .catch(function (error) {
          if (deferred) deferred.reject(error);
          button.disabled = false;
          button.textContent = label;
          // Fall back to the normal form post, which lands on the cart page.
          form.removeAttribute('data-dh-ux-cart-add');
          form.submit();
        });
    });
  });

  /* ---------- Cart arrival dates (2026-10-03, Duskhaven 2.0) ----------
   * <dh-cart-arrival data-min="6" data-max="12"> from snippets/dh-cart-faq.liquid turns "Arrives in about 6-12
   * business days" into real dates, counting business days (Monday to Friday) from today, exactly like
   * <dh-delivery-estimate> in blocks/dh-pdp-assurance.liquid. The drawer re-renders itself when the cart changes,
   * so the element puts the dates back whenever its text is reset.
   * 2026-10-04: data-min / data-max are the SLOWEST item's window (snippets/dh-cart-faq.liquid); when both are the same
   * day count, one date is shown instead of "X – X". */
  function addBusinessDays(days) {
    var date = new Date();
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    return date;
  }

  if (window.customElements && !customElements.get('dh-cart-arrival')) {
    customElements.define('dh-cart-arrival', class extends HTMLElement {
      connectedCallback() {
        this.render();
        if (!this.observer) {
          this.observer = new MutationObserver(this.render.bind(this));
          this.observer.observe(this, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-min', 'data-max'] });
        }
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }
      render() {
        var target = this.querySelector('[data-dh-arrival-text]');
        var min = parseInt(this.dataset.min, 10);
        var max = parseInt(this.dataset.max, 10);
        if (!target || !min || !max) return;
        var text;
        try {
          var format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', month: 'short', day: 'numeric' });
          var from = format.format(addBusinessDays(min));
          text = 'Arrives about ' + (min === max ? from : from + ' – ' + format.format(addBusinessDays(max)));
        } catch (e) {
          return;
        }
        if (target.textContent !== text) target.textContent = text;
      }
    });
  }
})();
